import { getSession } from "next-auth/react";

const bondHandler = async (event: any) => {
    const { modifiedField, modifiedFieldValue, viewMetadata, formData} = event;
    const session: any = await fetchUser();
    let bondContainerData: Record<string, any> = {}
    bondContainerData[modifiedField] = modifiedFieldValue?.value;
    const newFormData: any = {
        bondTncConfirmedByUser: { solidManyToOneLabel: session?.user?.user?.email, solidManyToOneValue: session?.user?.user?.id }
    };
    // If modified field is "bondDate", calculate "bondValidTillDate"
    if (modifiedField === "bondDate" && modifiedFieldValue) {
        const bondDate = new Date(modifiedFieldValue);
        bondDate.setFullYear(bondDate.getFullYear() + 1); // Add one year
        const formattedBondValidTillDate = bondDate.toISOString().split("T")[0]; // Format YYYY-MM-DD
        newFormData.manualBondValidTill = formattedBondValidTillDate;
    }
    return {
        layoutChanged: false,
        dataChanged: true,
        newFormData: newFormData
    }
}

const fetchUser = async () => {
    let session: any = await getSession();
    return session;
}
export default bondHandler;